import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { UtilitiesService } from '@app/core/services/utilities.service';
export type DialogSize = 'small' | 'medium' | 'large' | 'x-large' | 'xx-large';

@Component({
  selector: 'app-dialog-container',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>
      <div class="dialog-container__title-content">
        <ng-content select="[dialog-title]"></ng-content>
      </div>
      <button mat-icon-button aria-label="Cerrar diálogo" color="warn" class="dialog-container__close-button" (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <div mat-dialog-content>
      <ng-content select="[dialog-content]"></ng-content>
    </div>
    <div mat-dialog-actions align="end">
      <ng-content select="[dialog-actions]"></ng-content>
    </div>
  `,
  styles: [
    `
      h2[mat-dialog-title] {
        background-color: var(--accent-100) !important;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        padding: 16px 24px 0 24px;
        margin-bottom: 0;
      }
      .dialog-container__title-content {
        flex-grow: 1;
        align-items: center;
        display: flex;
        justify-content: center;
      }
      .dialog-container__close-button {
        flex-shrink: 0;
      }
      div[mat-dialog-content] {
        background-color: var(--accent-100) !important;
        padding: 16px 24px 16px 24px !important;
      }
      div[mat-dialog-actions] {
        background-color: var(--accent-100) !important;
        padding: 0 24px 16px 24px;
        display: flex;
        justify-content: flex-end;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogContainerComponent {
  readonly dialogRef = inject(MatDialogRef<DialogContainerComponent>);
  private readonly utilities = inject(UtilitiesService);
  private readonly data = inject<Partial<{ size: DialogSize }>>(MAT_DIALOG_DATA, { optional: true });
  constructor() {
    this.updateDialogSize();
  }

  private updateDialogSize(): void {
    if (!this.data?.size) {
      return;
    }

    const responsiveSizeMap: Record<DialogSize, { Web: string; Mobile: string }> = {
      small: { Web: '350px', Mobile: '90vw' },
      medium: { Web: '600px', Mobile: '95vw' },
      large: { Web: '900px', Mobile: '100vw' },
      'x-large': { Web: '1200px', Mobile: '100vw' },
      'xx-large': { Web: '90vw', Mobile: '100vw' },
    };

    const platform = this.utilities.getPlatform();
    const width = responsiveSizeMap[this.data.size][platform];

    this.dialogRef.updateSize(width);
  }
}
